export default __webpack_public_path__ + "static/media/icon.f2817498.svg";